import { HeadCell } from '../../../models/TableProps';
import { AdminDocumentHeadCellContent } from '../../../models/DocumentLibrary';

export const ADMIN_DOCUMENT_LIBRARY_HEAD_CELLS: HeadCell<AdminDocumentHeadCellContent>[] =
    [
        {
            id: 'name',
            numeric: false,
            disablePadding: false,
            label: 'NAME',
            sortable: true,
        },
        {
            id: 'description',
            numeric: false,
            disablePadding: false,
            label: 'DESCRIPTION',
            sortable: false,
        },
        {
            id: 'last_modified',
            numeric: false,
            disablePadding: false,
            label: 'LAST_MODIFIED',
            sortable: true,
        },
        {
            id: 'file_size',
            numeric: false,
            disablePadding: false,
            label: 'FILE_SIZE',
            sortable: true,
        },
        {
            id: 'is_active',
            numeric: false,
            disablePadding: false,
            label: 'ACTIVE',
            sortable: true,
        },
        {
            id: 'actions',
            numeric: false,
            disablePadding: false,
            label: 'DOWNLOAD',
            sortable: false,
        },
    ];
